import {
  useSnackbar,
  WBBox,
  WBFlex,
  WBLinkButton,
  WBTypography,
} from '@admiin-com/ds-web';
import { styled } from '@mui/material';
import { t } from 'i18next';
import PenIcon from '../../../assets/icons/pen-icon.svg';
import LoadSvgIcon from '../../component/LoadSvgIcon/LoadSvgIcon';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { isEntityOrContact } from '../../helpers/entities';
import { gql, useMutation } from '@apollo/client';
import {
  Contact,
  Entity,
  updateContact as UPDATE_CONTACT,
} from '@admiin-com/ds-graphql';
import EmailAddressModal from './EmailAddressModal';
interface Props {
  onAdd: () => void;
  contact?: Contact | Entity;
  checked: boolean;
  onCheck: (value: boolean) => void;
}
export const EmailAddress = ({ contact, checked = true, onCheck }: Props) => {
  const isContact = contact && isEntityOrContact(contact) === 'CONTACT';
  const email = isContact
    ? (contact as Contact)?.email
    : (contact as Entity)?.contact?.email;

  const name =
    (isContact ? (contact as Contact)?.name : (contact as Entity)?.name) ?? '';
  const hasEmail = Boolean(email) === true;
  const { setValue } = useFormContext();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [updateContact] = useMutation(gql(UPDATE_CONTACT));
  const showSnackbar = useSnackbar();
  const onUpdateEmail = async (email: string) => {
    try {
      if (isContact) {
        if (contact?.id) {
          const { data: updatedContactData } = await updateContact({
            variables: {
              input: {
                id: contact?.id,
                entityId: (contact as Contact).entityId,
                email: email,
              },
            },
          });
          const updatedContact = updatedContactData?.updateContact;
          if (updatedContact) {
            setValue('to', updatedContact);
          }
        }
      }
    } catch (e: any) {
      showSnackbar({
        message: t(e?.message, { ns: 'errors' }),
        severity: 'error',
        vertical: 'bottom',
      });
    }
  };
  return (
    <Container>
      {/*{hasEmail && <WBCheckbox checked={checked} disabled />}*/}
      <WBBox flex={1}>
        <WBTypography fontWeight={'bold'}>
          {t('sendViaEmail', { ns: 'taskbox' })}
        </WBTypography>
        <WBTypography color={'text.secondary'}>
          {email || t('noEmail', { ns: 'taskbox' })}
        </WBTypography>
      </WBBox>
      {isContact && (
        <WBBox>
          <WBLinkButton
            color="primary.main"
            onClick={() => {
              setModalOpen(true);
            }}
          >
            {hasEmail ? (
              <LoadSvgIcon component={PenIcon} width={25} height={25} />
            ) : (
              <WBTypography color={'primary.main'}>
                {t('addEmail', { ns: 'taskbox' })}
              </WBTypography>
            )}
          </WBLinkButton>
        </WBBox>
      )}
      {modalOpen && (
        <EmailAddressModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onOK={async (email: string) => {
            await onUpdateEmail(email);
          }}
          name={name}
          defaultEmail={email ?? ''}
          disabledEdit={!isContact}
        />
      )}
    </Container>
  );
};

const Container = styled(WBFlex)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  padding: theme.spacing(2),
}));
